import { Component, Input } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';

type WPRendered = { rendered: string };

@Component({
    selector: 'app-blog-card',
    templateUrl: './blog-card.component.html',
    styleUrls: ['./blog-card.component.scss']
})
export class BlogCardComponent {
    @Input() img!: string;
    @Input() title!: string | WPRendered;
    @Input() text!: string | WPRendered;
    @Input() link!: any;
    @Input() id!: number;
    /** Fecha de publicación (ISO 8601). Si se pasa, se muestra como "Nov 10, 2025". */
    @Input() date?: string;
    /** Tiempo estimado de lectura en minutos (entero). */
    @Input() readingTime?: number;
    /** Categoría/etiqueta del post — aparece como badge sobre la imagen. */
    @Input() category?: string;
    /** Nombre del autor — aparece junto a la fecha. */
    @Input() author?: string;

    constructor(private langService: LanguageService) { }

    get hasMeta(): boolean {
        return !!(this.date || this.readingTime || this.author);
    }

    get formattedDate(): string {
        if (!this.date) return '';
        try {
            const d = new Date(this.date);
            if (isNaN(d.getTime())) return '';
            return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        } catch { return ''; }
    }

    get titleText(): string {
        if (!this.title) return '';
        return typeof this.title === 'string' ? this.title : this.title.rendered;
    }

    get textText(): string {
        if (!this.text) return '';
        return typeof this.text === 'string' ? this.text : this.text.rendered;
    }

    get imageUrl(): string {
        if (this.img && this.img.trim()) {
            return this.optimizeCardImage(this.img);
        }
        return 'assets/img/default.png';
    }

    get imageSrcset(): string | null {
        const raw = (this.img || '').trim();
        if (!raw) return null;
        if (raw.includes('informative-section-background.webp')) {
            return 'assets/imgs/informative-section-background.webp 640w, assets/imgs/informative-section-background.webp 1920w';
        }
        return null;
    }

    get routerLinkValue(): any {
        if (Array.isArray(this.link)) return this.link;
        const asString = (this.link || '').toString();
        if (!asString) return ['/buenos-aires-blog', this.langService.lang];
        const clean = asString.startsWith('/') ? asString.substring(1) : asString;
        return this.langService.build(clean, this.langService.lang);
    }

    private optimizeCardImage(source: string): string {
        if (source.includes('informative-section-background.webp')) {
            return source.replace('informative-section-background.webp', 'informative-section-background.webp');
        }
        return source;
    }
}
